import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './lib/riveInit' // self-host Rive WASM (kills unpkg dependency)
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"
import * as Sentry from "@sentry/react";
import { reloadOnceForChunkError } from "./lib/lazyWithRetry";
import { IGNORED_ERROR_PATTERNS } from "./lib/ignoredErrors";

Sentry.init({
  dsn: "https://b8e88bff5de9dcc9c2b1611ee8bdaf52@o4510429661757440.ingest.us.sentry.io/4510429663199232",
  sendDefaultPii: true,
  ignoreErrors: IGNORED_ERROR_PATTERNS,
});

// Auto-recover from stale dynamic-import chunks after a new deploy invalidates
// previously-hashed chunks (e.g. "Failed to fetch dynamically imported module",
// "'text/html' is not a valid JavaScript MIME type", "Unable to preload CSS").
// Hard-reload once so the browser fetches fresh index.html + chunk hashes;
// guarded by sessionStorage to avoid loops (see lib/lazyWithRetry).
if (typeof window !== "undefined") {
  // Vite fires this when a lazy chunk or its CSS preload fails. Start the
  // reload here, but never preventDefault(): that makes Vite resolve the import
  // with undefined, which crashes the caller before the reload lands. Vite
  // rethrows instead, and importWithReload sees the reload is under way and waits.
  window.addEventListener("vite:preloadError", (e) => {
    const err = (e as Event & { payload?: unknown }).payload as { message?: string } | undefined;
    reloadOnceForChunkError(String(err?.message ?? err ?? ""));
  });
  window.addEventListener("error", (e) => { reloadOnceForChunkError(String(e?.message || "")); });
  window.addEventListener("unhandledrejection", (e: PromiseRejectionEvent) => {
    reloadOnceForChunkError(String(e?.reason?.message || e?.reason || ""));
  });
}



// NOTE: React.StrictMode intentionally double-mounts components in dev. That
// breaks Stripe's <EmbeddedCheckout> ("you cannot have multiple Embedded Checkout
// objects") and forces a click-to-load workaround. Disabled so the embedded
// checkout can auto-load. StrictMode is a no-op in production builds either way.
createRoot(document.getElementById("root")!).render(
  <>
    <Analytics/>
    <SpeedInsights/>
    <App />
  </>
)